export default "__VITE_ASSET__PGkDhF1Q__"